export default __webpack_public_path__ + "static/media/fettuccine-alfredo-dish.91786c75.jpg";